
namespace GeniuzPOS.PriceChange {

    @Serenity.Decorators.registerClass()
    export class AddPriceChangeDialog extends Serenity.EntityDialog<AddPriceChangeRow, any> {
        protected getFormKey() { return AddPriceChangeForm.formKey; }
        protected getIdProperty() { return AddPriceChangeRow.idProperty; }
        protected getLocalTextPrefix() { return AddPriceChangeRow.localTextPrefix; }
        protected getNameProperty() { return AddPriceChangeRow.nameProperty; }
        protected getService() { return AddPriceChangeService.baseUrl; }
        protected getDeletePermission() { return AddPriceChangeRow.deletePermission; }
        protected getInsertPermission() { return AddPriceChangeRow.insertPermission; }
        protected getUpdatePermission() { return AddPriceChangeRow.updatePermission; }

        protected form = new AddPriceChangeForm(this.idPrefix);
        public price1: number;
        public price2: number;
        public price3: number;
        public price4: number;
        public price5: number;
        public price6: number;

        public sku: string;
        public ratio: number;
        public qty: number;
        public skuCost: number;

        constructor() {
            super();

            this.form = new AddPriceChangeForm(this.idPrefix);
            this.form.PluCode.changeSelect2(e => {
                var plucode = Q.toId(this.form.PluCode.value);
                var plu : string = this.form.PluCode.value
                if (plucode != null) {

                    Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice1.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice2.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice3.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice4.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice5.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice6.element, false);

                    this.form.SellUnitPrice1.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice1;
                    this.form.SellUnitPrice2.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice2;
                    this.form.SellUnitPrice3.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice3;
                    this.form.SellUnitPrice4.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice4;
                    this.form.SellUnitPrice5.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice5;
                    this.form.SellUnitPrice6.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice6;

                    this.sku = Product.CsPluRow.getLookup().itemById[plu].SkuCode;
                    this.ratio = Product.CsPluRow.getLookup().itemById[plu].SellUnitRatio;
                    this.qty =Product.CsSkuRow.getLookup().itemById[ this.sku].QtyOnhand
                    if(this.qty < 1){
                        this.skuCost = this.ratio*(Product.CsSkuRow.getLookup().itemById[ this.sku].StockCostValue / (1))
                    }else{
                        this.skuCost = this.ratio*(Product.CsSkuRow.getLookup().itemById[ this.sku].StockCostValue / (this.qty || 1));
                        }
                    console.log( this.skuCost)
                }
            });

            this.form.SellUnitPrice1.change(e => {
                
                var plu : string = this.form.PluCode.value
                this.price1 = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice1;
                if (this.form.SellUnitPrice1.value != this.price1) {
                    this.form.SellUnitPrice1Fg.value = true;
                } else {
                    this.form.SellUnitPrice1Fg.value = false;
                }
            });
            this.form.SellUnitPrice2.change(e => {
                
                var plu : string = this.form.PluCode.value
                this.price2 = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice2;
                if (this.form.SellUnitPrice2.value != this.price2) {
                    this.form.SellUnitPrice2Fg.value = true;
                } else {
                    this.form.SellUnitPrice2Fg.value = false;
                }
            });
            this.form.SellUnitPrice3.change(e => {
                var plu : string = this.form.PluCode.value
                this.price3 = Product.CsPluRow.getLookup().itemById[plu].SellUnitPrice3;
                if (this.form.SellUnitPrice3.value != this.price3) {
                    this.form.SellUnitPrice3Fg.value = true;
                } else {
                    this.form.SellUnitPrice3Fg.value = false;
                }
            });
            this.form.SellUnitPrice4.change(e => {
                var plucode : string = this.form.PluCode.value
                this.price4 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice4;
                if (this.form.SellUnitPrice4.value != this.price4) {
                    this.form.SellUnitPrice4Fg.value = true;
                } else {
                    this.form.SellUnitPrice4Fg.value = false;
                }
            });
            this.form.SellUnitPrice5.change(e => {
                var plucode : string = this.form.PluCode.value
                this.price5 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice5;
                if (this.form.SellUnitPrice5.value != this.price5) {
                    this.form.SellUnitPrice5Fg.value = true;
                } else {
                    this.form.SellUnitPrice5Fg.value = false;
                }
            });
            this.form.SellUnitPrice6.change(e => {
                var plucode : string = this.form.PluCode.value
                this.price6 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice6;
                if (this.form.SellUnitPrice6.value != this.price6) {
                    this.form.SellUnitPrice6Fg.value = true;
                } else {
                    this.form.SellUnitPrice6Fg.value = false;
                }
            });

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSavePosBtn: Serenity.ToolButton =
                {
                    title: "บันทึกรายการ",
                    hint: "Post and Save",
                    separator: false,
                    cssClass: "button-save-post",
                    icon: "fa fa-save",
                    hotkey: 'alt+shift+s',
                    onClick: (e) => {

                        var plucode : string = this.form.PluCode.value
                        this.price1 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice1;
                        this.price2 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice2;
                        this.price3 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice3;
                        this.price4 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice4;
                        this.price5 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice5;
                        this.price6 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice6;
                       

                        Q.confirm(
                            this.price1 + " > " + this.form.SellUnitPrice1.value + "\r\n" +
                            this.price2 + " > " + this.form.SellUnitPrice2.value + "\r\n" +
                            this.price3 + " > " + this.form.SellUnitPrice3.value + "\r\n" +
                            this.price4 + " > " + this.form.SellUnitPrice4.value + "\r\n" +
                            this.price5 + " > " + this.form.SellUnitPrice5.value + "\r\n" +
                            this.price6 + " > " + this.form.SellUnitPrice6.value + "\r\n" +
                             "(ต้นทุนปัจจุบัน " + this.skuCost +" )"+ "\r\n" +
                            '    ยืนยันการบันทึก'
                            ,
                            () => {
                                this.form.PostFg.value = "0";
                                this.form.PostFg.forceUpdate();
                                this.form.ApproveFg.value = "0";
                                this.form.ApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });

                    }
                };
                buttons.push(newSavePosBtn);
                // let SaveBtn: Serenity.ToolButton =
                // {
                //     title: "บันทึกและทำรายการถัดไป",
                //     hint: "Save",
                //     separator: false,
                //     cssClass: "button-save-notpost",
                //     icon: "fa fa-save",
                //     hotkey: 'alt+s',
                //     onClick: (e) => {

                //         this.form.PostFg.value = "0";
                //         this.form.PostFg.forceUpdate();
                //         e.preventDefault();
                //         this.saveAndNew();

                //     }

                // };

                // buttons.push(SaveBtn);

                let applyBtn: Serenity.ToolButton =
                {
                    title: "ปรับปรุงข้อมูลและปิด",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-apply",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {
                        

                        this.form.PostFg.value = "0";
                        this.form.PostFg.forceUpdate();
                        this.save((response) => {
                            this.dialogClose();
                        });

                    }

                };

                buttons.push(applyBtn);
                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบ'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-trash",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบ', () => {
                            this.doDelete(() => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);
            }



            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );


            return buttons;
        }

        private saveAndNew() {
            let e = this.entity; let f = this.form;
            this.save((response) => {

                this.loadEntity(e);
            });
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew) {

                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice1.element, true);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice2.element, true);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice3.element, true);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice4.element, true);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice5.element, true);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice6.element, true);
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-apply').hide();
            }
            if (this.isEditMode) {
                

                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice1.element, false);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice2.element, false);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice3.element, false);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice4.element, false);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice5.element, false);
                Serenity.EditorUtils.setReadonly(this.form.SellUnitPrice6.element, false);
                var effdate = this.entity.EffectiveDate
                if (effdate != null) {
                    Serenity.EditorUtils.setReadonly(this.form.PluCode.element, true);
                    var date = $.datepicker.formatDate('yymmdd', new Date());

                    var a = effdate.split('T')[0];
                    var effectdate = a.split('-')[0] + a.split('-')[1] + a.split('-')[2]

                    if (effectdate < date) {
                        //Q.confirm(effectdate + date, () => { });
                        if (this.entity.PostFg == 1) {
                            this.toolbar.findButton('creates-followup-button').hide();
                            this.toolbar.findButton('genarate-po-button').hide();
                            this.toolbar.findButton('button-save-post').hide();
                            // this.toolbar.findButton('button-save-notpost').hide();
                            this.toolbar.findButton('delete-button').hide();
                            this.toolbar.findButton('button-apply').hide();
                        }
                        if (this.entity.PostFg == 0) {
                            if(this.entity.ApproveFg == 0){
                            Q.confirm("วันที่มีผลบังคับใช้  " + a + "  เป็นวันที่ย้อนหลัง", () => { });
                            this.toolbar.findButton('delete-button').show();
                            this.toolbar.findButton('button-apply').show();
                            // this.toolbar.findButton('button-save-notpost').hide();
                        }else{
                            this.toolbar.findButton('creates-followup-button').hide();
                            this.toolbar.findButton('genarate-po-button').hide();
                            this.toolbar.findButton('button-save-post').hide();
                            // this.toolbar.findButton('button-save-notpost').hide();
                            this.toolbar.findButton('delete-button').hide();
                            this.toolbar.findButton('button-apply').hide();
                        }
                        }
                    } else {
                        if (this.entity.PostFg == 1) {
                            this.toolbar.findButton('creates-followup-button').hide();
                            this.toolbar.findButton('genarate-po-button').hide();
                            this.toolbar.findButton('button-save-post').hide();
                            // this.toolbar.findButton('button-save-notpost').hide();
                            this.toolbar.findButton('delete-button').hide();
                            this.toolbar.findButton('button-apply').hide();
                        }
                        if (this.entity.PostFg == 0) {
                            if(this.entity.ApproveFg == 0){
                            this.toolbar.findButton('delete-button').show();
                            this.toolbar.findButton('button-apply').show();
                            // this.toolbar.findButton('button-save-notpost').hide();
                            this.toolbar.findButton('button-save-post').hide();
                        }
                        // else{
                        //     // this.toolbar.findButton('creates-followup-button').hide();
                        //     // this.toolbar.findButton('genarate-po-button').hide();
                        //     // this.toolbar.findButton('button-save-post').hide();
                        //     // // this.toolbar.findButton('button-save-notpost').hide();
                        //     // this.toolbar.findButton('delete-button').hide();
                        //     // this.toolbar.findButton('button-apply').hide();
                        // }
                        }

                    }
                }
            }
        }
    }
}